export default {
  scope: ({ site, path }) => site.includes('paroc') || path.includes('paroc'),
  colors: { brand: '#CE1126' },
  fonts: { heading: 'Oswald, sans-serif' },
  icons: { tools: { textColor: 'BrandParoc' } }
};
